import { useState, useEffect } from "react";
import { FormControl, Select, MenuItem, TextField, Grid, FormHelperText } from "@mui/material";
import { addDays } from 'date-fns';

const EmployeeInfo = ({ page, setPage, formData, setFormData }) => {
    const [incomeTypeError, setIncomeTypeError] = useState(null);
    const [employerError, setEmployerError] = useState(null);
    const [jobTitleError, setJobTitleError] = useState(null);
    const [workPhoneError, setWorkPhoneError] = useState(null);
    const [employedMonthsError, setEmployedMonthsError] = useState(null);
    const [payFrequencyError, setPayFrequencyError] = useState(null);
    const [payDateError, setPayDateError] = useState(null);
    const [secondPayDateError, setSecondPayDateError] = useState(null);
    const [paymentDatesError, setPaymentDatesError] = useState(null);

    var currentDate = new Date();
    const exampleDate1 = currentDate.toISOString().split("T")[0];
    const exampleDate2 = addDays(currentDate, 1).toISOString().split("T")[0];

    const [employed, setEmployed] = useState(false);
    const onEmploymentChange = (e) => {
        setFormData({ ...formData, incomeType: e.target.value });
        setIncomeTypeError(null);
    };

    const onEmployementMonthsChange = (e) => {
        setFormData({ ...formData, employedMonths: parseInt(e.target.value, 10) });
        setEmployedMonthsError(null);
    }
    const onEmployerChange = (e) => {
        setFormData({ ...formData, employer: e.target.value });
        setEmployerError(null);
    }
    const onJobTitleChange = (e) => {
        setFormData({ ...formData, jobTitle: e.target.value });
        setJobTitleError(null);
    }
    const onWorkPhoneChange = (e) => {
        setWorkPhoneError(null);
        if (e.target.value.length > 10) {
            e.preventDefault(e);
        } else {
            setFormData({ ...formData, workPhone: e.target.value });
        }
    }
    const onPayFrequencyChange = (e) => {
        setFormData({ ...formData, payFrequency: e.target.value });
        setPayFrequencyError(null);
    }
    const onPayDateChange = (e) => {
        setFormData({ ...formData, payDate1: e.target.value });
        setPayDateError(null);
        setPaymentDatesError(null);
    }
    const onSecondPayDateChange = (e) => {
        setFormData({ ...formData, payDate2: e.target.value });
        setSecondPayDateError(null);
        setPaymentDatesError(null);
    }

    const validateInfo = () => {
        var valid = true;

        if (employed) {
            if (formData.employer === "") {
                setEmployerError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            } else {
                setEmployerError(null);
            }

            if (formData.jobTitle === "") {
                setJobTitleError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            } else {
                setEmployerError(null);
            }

            if (formData.workPhone === "") {
                setWorkPhoneError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            } else if (formData.workPhone.length < 10) {
                setWorkPhoneError(formData.lang === "fr" ? "Doit contenir 10 chiffres (sans espace ni tiret)" : "Must be 10 digits (no space or hyphens)");
                valid = false;
            } else {
                setEmployerError(null);
            }

            if (formData.employedMonths === "") {
                setEmployedMonthsError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            } else {
                setEmployedMonthsError(null);
            }

            if (formData.payFrequency === "") {
                setPayFrequencyError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            } else {
                setPayFrequencyError(null);
            }

            //payment dates
            if (formData.payDate1 === "") {
                setPayDateError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            }

            if (formData.payDate2 === "") {
                setSecondPayDateError(formData.lang === "fr" ? "Ceci est requis" : "This field is required");
                valid = false;
            }

            if (Date.parse(formData.payDate1) < currentDate || Date.parse(formData.payDate2) < currentDate) {
                if (Date.parse(formData.payDate1) < currentDate) {
                    setPayDateError(formData.lang === "fr" ? "Cette date est passée" : "This date has passed");
                    valid = false;
                }
                if (Date.parse(formData.payDate2) < currentDate) {
                    setSecondPayDateError(formData.lang === "fr" ? "Cette date est passée" : "This date has passed");
                    valid = false;
                }
            } else if (formData.payDate1 !== "" && formData.payDate2 !== "") {
                const d1 = Date.parse(formData.payDate1);
                const d2 = Date.parse(formData.payDate2);
                if (d1 >= d2) {
                    setPaymentDatesError(formData.lang === "fr" ? "La deuxième date de paiement doit être postérieure à la première." : "Second payment date needs to be after the first.");
                    valid = false;
                } else {
                    setPaymentDatesError(null);
                }
            }
        }

        if (valid === true) {
            window.dataLayer.push({'event': 'loan_step5', 'loanEvent': 'step5', 'loanEventID': 6});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step5q', 'loanEvent': 'step5q', 'loanEventID': '6q'});
            setPage(page + 1);
            moveToTop();
        }
    }

    useEffect(() => {
        if (formData.incomeType === 'full_time' || formData.incomeType === 'part_time'
            || formData.incomeType === 'self_employed' || formData.incomeType === 'gig_worker') {
            setEmployed(true);
        } else {
            setEmployed(false);
        }
    }, [formData]);

    useEffect(() => {
        setIncomeTypeError(null);
        setEmployerError(null);
        setJobTitleError(null);
        setWorkPhoneError(null);
        setEmployedMonthsError(null);
        setPayFrequencyError(null);
        setPayDateError(null);
        setSecondPayDateError(null);
        setPaymentDatesError(null);
    }, [formData.lang]);

    const moveToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Quelle est votre source de revenus?" : "What is your source of income?"}</div>
                <FormControl>
                    <Select
                        variant="outlined"
                        value={formData.incomeType}
                        onChange={(e) => onEmploymentChange(e)}
                    >
                        <MenuItem value={"full_time"}>{formData.lang === "fr" ? "À temps plein" : "Full-time"}</MenuItem>
                        <MenuItem value={"part_time"}>{formData.lang === "fr" ? "À temps partiel" : "Part-time"}</MenuItem>
                        <MenuItem value={"self_employed"}>{formData.lang === "fr" ? "Travailleur indépendant" : "Self-Employed"}</MenuItem>
                        <MenuItem value={"gig_worker"}>{formData.lang === "fr" ? "Travailleur à la demande" : "Gig Worker"}</MenuItem>
                        <MenuItem value={"retired"}>{formData.lang === "fr" ? "À la retraite" : "Retired"}</MenuItem>
                        <MenuItem value={"disability"}>{formData.lang === "fr" ? "Invalidité" : "Disability"}</MenuItem>
                        <MenuItem value={"social_security"}>{formData.lang === "fr" ? "Sécurité sociale" : "Social Security"}</MenuItem>
                        <MenuItem value={"unemployed"}>{formData.lang === "fr" ? "Sans emploi" : "Unemployed"}</MenuItem>
                    </Select>
                    <FormHelperText style={{ color: "red" }}>{incomeTypeError}</FormHelperText>
                </FormControl>

                {employed ?
                    <div>
                        <div className="textfield-label">{formData.lang === "fr" ? "Employeur" : "Employer"}</div>
                        <TextField
                            value={formData.employer}
                            onChange={onEmployerChange} />
                        <div className="error-text">{employerError}</div>
                        <div className="textfield-label">{formData.lang === "fr" ? "Titre d'emploi" : "Job Title"}</div>
                        <TextField
                            value={formData.jobTitle}
                            onChange={onJobTitleChange} />
                        <div className="error-text">{jobTitleError}</div>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div className="textfield-label">{formData.lang === "fr" ? "Téléphone de travail" : "Work Phone"}</div>
                                <TextField
                                    type="number"
                                    value={formData.workPhone}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') && e.preventDefault()}
                                    onChange={onWorkPhoneChange}
                                />
                                <div className="error-text">{workPhoneError}</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className="textfield-label">{formData.lang === "fr" ? "Vous avez travaillé" : "Time at Job"}</div>
                                <FormControl>
                                    <Select
                                        variant="outlined"
                                        value={formData.employedMonths}
                                        onChange={onEmployementMonthsChange}
                                    >
                                        <MenuItem value={"6"}>{formData.lang === "fr" ? "6 mois" : "6 months"}</MenuItem>
                                        <MenuItem value={"12"}>{formData.lang === "fr" ? "1 an" : "1 year"}</MenuItem>
                                        <MenuItem value={"24"}>{formData.lang === "fr" ? "2 ans" : "2 years"}</MenuItem>
                                        <MenuItem value={"36"}>{formData.lang === "fr" ? "Plus de 3 ans" : "3+ years"}</MenuItem>
                                    </Select>
                                </FormControl>
                                <div className="error-text">{employedMonthsError}</div>
                            </Grid>
                        </Grid>

                        <div className="textfield-label">{formData.lang === "fr" ? "Fréquence de paiement" : "Frequency of Payment"}</div>
                        <FormControl>
                            <Select
                                variant="outlined"
                                value={formData.payFrequency}
                                onChange={onPayFrequencyChange}
                            >
                                <MenuItem value={"WEEKLY"}>{formData.lang === "fr" ? "Chaque semaine" : "Weekly"}</MenuItem>
                                <MenuItem value={"BIWEEKLY"}>{formData.lang === "fr" ? "Deux fois par semaine" : "Bi-weekly"}</MenuItem>
                                <MenuItem value={"TWICEMONTHLY"}>{formData.lang === "fr" ? "Deux fois par mois" : "Twice Monthly"}</MenuItem>
                                <MenuItem value={"MONTHLY"}>{formData.lang === "fr" ? "Mensuel" : "Monthly"}</MenuItem>
                            </Select>
                            <div className="error-text">{payFrequencyError}</div>
                        </FormControl>

                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <div className="textfield-label">{formData.lang === "fr" ? "Prochaine date de paie" : "Next Pay Date"}</div>
                                <TextField
                                    InputProps={{ inputProps: { min: exampleDate1, max: "9999-12-31" } }}
                                    type="date"
                                    variant="outlined"
                                    value={formData.payDate1}
                                    onChange={onPayDateChange} />
                                <div className="error-text">{payDateError}</div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className="textfield-label">{formData.lang === "fr" ? "Date de paie apres la suivante" : "Next Pay Date After"}</div>
                                <TextField
                                    InputProps={{ inputProps: { min: exampleDate2, max: "9999-12-31" } }}
                                    type="date"
                                    variant="outlined"
                                    value={formData.payDate2}
                                    onChange={onSecondPayDateChange} />
                                <div className="error-text">{secondPayDateError}</div>
                            </Grid>
                        </Grid>
                        <div className="error-text">{paymentDatesError}</div>
                    </div> : null}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                                moveToTop();
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                if (formData.incomeType === "") {
                                    setIncomeTypeError(formData.lang === "fr" ? "Veuillez indiquer votre source de revenus." : "Please provide your source of income.");
                                } else {
                                    validateInfo();
                                }
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default EmployeeInfo;